import { Link, styled } from '@mui/material';
import { TableCell } from '../../common';
export var LEVEL_ROW_STICKIES = ['22rem'];
export var DAILY_NEST_LEVELS = {
  1: '2rem',
  2: '3rem',
  3: '4rem',
  4: '5rem',
  5: '6rem'
};
export var LEVEL_ROW_INDENTS = {
  metric: DAILY_NEST_LEVELS[1],
  lob: DAILY_NEST_LEVELS[2],
  queue: DAILY_NEST_LEVELS[3],
  country: DAILY_NEST_LEVELS[4],
  location: DAILY_NEST_LEVELS[5]
};
export var StyledLevelFirstCell = styled(TableCell)(function (_a) {
  var paddingLeft = _a["aria-label"];
  return {
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&.MuiTableCell-root': {
      paddingLeft: paddingLeft
    }
  };
});
export var StyledDailyHeaderCell = styled(TableCell)(function (_a) {
  var theme = _a.theme;
  return {
    whiteSpace: 'nowrap',
    minWidth: '7rem !important',
    color: "".concat(theme.palette.text.primary, " !important"),
    fontWeight: 'bold',
    backgroundColor: "".concat(theme.palette.grey[400], " !important")
  };
});
export var StyledBannerCell = styled(TableCell)(function (_a) {
  var theme = _a.theme;
  return {
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightBold,
    padding: theme.spacing(1),
    border: 'none',
    borderBottom: 'none'
  };
});
export var FixedTableBanner = styled('div')(function (_a) {
  var theme = _a.theme;
  return {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightBold,
    padding: '0.625rem',
    textAlign: 'center',
    textTransform: 'uppercase'
  };
});
export var StyledDateLink = styled(Link)(function () {
  return {
    cursor: 'pointer',
    textDecoration: 'underline',
    fontWeight: 'bold',
    '&:hover': {
      opacity: 0.8
    }
  };
});